import React from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { getPolicy } from "@/content/policies";

export default function PolicyDetail() {
  const { slug } = useParams();
  const policy = getPolicy(slug || "");

  return (
    <div className="max-w-3xl mx-auto px-6 py-10">
      <Link
        to="/policies"
        className="inline-flex items-center gap-2 text-sm text-tb-muted hover:text-tb-navy font-ui mb-6"
        data-testid="policy-detail-back-link"
      >
        <ArrowLeft className="w-4 h-4" />
        Back to Policies &amp; Disclosures
      </Link>
      {policy ? (
        <>
          <h1 className="font-serif text-4xl text-tb-navy mb-6" data-testid={`policy-title-${policy.slug}`}>
            {policy.title}
          </h1>
          <pre
            data-testid={`policy-body-${policy.slug}`}
            className="whitespace-pre-wrap font-ui text-[15px] leading-relaxed text-tb-navy"
            style={{ fontFamily: "inherit" }}
          >
            {policy.body}
          </pre>
        </>
      ) : (
        <p className="font-ui italic text-tb-muted">Policy not found.</p>
      )}
    </div>
  );
}
